import { GameConstants } from "./GameConstants";
import { GameVars } from "./GameVars";
import { Difficulty, GameData, GameType, Language } from "./Types";

export class PersistentDataManager {

    public static readGameData(): void {

        const storedGameData = localStorage.getItem(GameConstants.SAVED_GAME_DATA_KEY);

        GameVars.gameData = storedGameData === null
            ? {
                schema: 1,
                musicMuted: false,
                sfxMuted: false,
                language: Language.EN,
                difficulty: Difficulty.EASY,
                gameType: GameType.CHICAGO,
                humanDeclares: true,
                playableCardHints: true,
                useSameSeedForEachGame: false,
                showLastHand: true,
                playerAvatarId: 3
            }
            : JSON.parse(storedGameData) as GameData;
    }

    public static updateGameData<TKey extends keyof GameData>(key: TKey, value: GameData[TKey]): void {

        if (!GameVars.gameData) {
            return;
        }

        GameVars.gameData[key] = value;
        localStorage.setItem(GameConstants.SAVED_GAME_DATA_KEY, JSON.stringify(GameVars.gameData));
    }
}
